import { render, staticRenderFns } from "./PurchasingProductModal.vue?vue&type=template&id=d52c528e&"
import script from "./PurchasingProductModal.vue?vue&type=script&lang=js&"
export * from "./PurchasingProductModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports